module.exports = __webpack_public_path__ + "img/yslogo.54971d8b.png";